import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}
export default new Router({
	routes: [{
		path: '/',
		name: 'topNav',
		component: r => require.ensure([], () => r(require('@/components/topNav')),'index'),
		children: [{
				name: 'index',
				path: 'index',
				component: r => require.ensure([], () => r(require('@/components/Index/index')),'index'),
				meta: {
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
			},
			{
				name: 'scoreList',
				path: 'scoreList',
				component: r => require.ensure([], () => r(require('@/components/scoreReport/scoreList.vue')),'scoreList'),
				meta: {
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
			},
			{
				name: 'scoreNav',
				path: 'scoreNav',
				component: r => require.ensure([], () => r(require('@/components/scoreReport/scoreNav')),'scoreNav'),
				meta: {
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
				children: [{
					name: 'test_profile',
					path: 'test_profile',
					component: r => require.ensure([], () => r(require('@/components/scoreReport/Tpl/testProfile')),'test_profile'),
					meta: {
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					},
				}, {
					name: 'score_ranking',
					path: 'score_ranking',
					component: r => require.ensure([], () => r(require('@/components/scoreReport/Tpl/scoreRanking')),'score_ranking'),
					meta: {
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					},
				}, {
					name: 'online_ana',
					path: 'online_ana',
					component: r => require.ensure([], () => r(require('@/components/scoreReport/Tpl/onlineAna')),'online_ana'),
					meta: {
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					},
				}, {
					name: 'avg_ana',
					path: 'avg_ana',
					component: r => require.ensure([], () => r(require('@/components/scoreReport/Tpl/avgAna')),'avg_ana'),
					meta: {
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					},
				}, {
					name: 'score_scaleAna',
					path: 'score_scaleAna',
					component: r => require.ensure([], () => r(require('@/components/scoreReport/Tpl/scoreScaleAna')),'score_scaleAna'),
					meta: {
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					},
				}, {
					name: 'rank_ana',
					path: 'rank_ana',
					component: r => require.ensure([], () => r(require('@/components/scoreReport/Tpl/rankAna')),'rank_ana'),
					meta: {
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					},
				}, {
					name: 'four_rateAna',
					path: 'four_rateAna',
					component: r => require.ensure([], () => r(require('@/components/scoreReport/Tpl/fourRateAna')),'four_rateAna'),
					meta: {
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					},
				}, {
					name: 'test_paper_ana',
					path: 'test_paper_ana',
					component: r => require.ensure([], () => r(require('@/components/scoreReport/Tpl/testPaperAna.vue')),'test_paper_ana'),
					meta: {
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					},
				}, {
					name: 'knowledge_ana',
					path: 'knowledge_ana',
					component: r => require.ensure([], () => r(require('@/components/scoreReport/Tpl/knowledgeAna.vue')),'knowledge_ana'),
					meta: {
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					},
				}]
			}
		]
	}]
})



// WEBPACK FOOTER //
// ./src/router/index.js